import React from 'react';
import {Row, Col} from 'react-bootstrap';
import '../../styles/SideNav/Question.scss';

function Question({onChange, items, currentQuestion, translations}) {
 
  return (
    <div className="container position-relative pl-0 pr-0">
      {items?.map((ques, i) => (
        <div
          key={i}
          id={ques.vPnum}
          tabIndex={i}
          className={`p-3 question position-relative ${ques.v === currentQuestion && 'active'}`}
          style={{border: '1px solid #CDCDCD'}}
          onClick={() => {
            onChange(ques.v);
          }}
        >
          <div className="h-100 w-100 left-0 top-0 position-absolute overlay"></div>
          <div className="fw-bold">
            <Row>
              <Col lg={1}>
                <span className="pr-2 fw-normal">{ques.vPay.vQnum}</span>
              </Col>
              <Col>
                <QuestionLabel currentQuestion={ques} translations={translations} />
              </Col>
            </Row>
          </div>
        </div>
      ))}
      {/* LEFT HERE INTENTIONALLY to showcase the inconsistency of the data questionLabel.filter(q => q.trans_lang_program_num ==== ques.v) */}
    </div>
  );
}

function QuestionLabel({currentQuestion, translations}) {
  // console.log(translations);
  // console.log(currentQuestion);
  const transText = translations?.WebsiteText?.filter(w => {
    return w.trans_lang_program_num === currentQuestion.v;
  })[0]?.trans_lang_variable_text;

  return transText ?? currentQuestion.vPay?.vlang;
}

export default Question;
